import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;
`
